import { Laptop, Home, Sun } from "lucide-react";
import { Chapter, Reveal } from "./Reveal";
import { PRICING } from "../../data/content";

export const Pricing = () => (
    <section id="pricing" data-testid="pricing-section" className="py-28 md:py-40">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <Chapter
                index="Ch. 08"
                eyebrow="Transparent pricing"
                title={
                    <>
                        Honest rates,
                        <br />
                        <em className="text-navy">no lock-in programs.</em>
                    </>
                }
                testid="pricing-heading"
            />

            <div className="grid md:grid-cols-2 gap-px bg-ink/10 border border-ink/10">
                {PRICING.map((p, i) => (
                    <Reveal key={p.id} delay={i * 0.1} className="bg-bone">
                        <div data-testid={`pricing-card-${p.id}`} className="p-10 md:p-14 h-full">
                            <div className="flex items-center gap-3 mb-2">
                                {p.id === "online" ? (
                                    <Laptop className="w-5 h-5 text-navy" strokeWidth={1.5} />
                                ) : (
                                    <Home className="w-5 h-5 text-navy" strokeWidth={1.5} />
                                )}
                                <h3 className="font-serif text-3xl text-ink">{p.name}</h3>
                            </div>
                            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate2 mb-10">
                                {p.detail}
                            </p>
                            <div>
                                {p.tiers.map((t) => (
                                    <div
                                        key={t.duration}
                                        data-testid={`pricing-tier-${p.id}-${t.duration.replace(/[^a-z0-9]+/g, "-")}`}
                                        className="flex items-baseline justify-between border-t hairline py-5 group"
                                    >
                                        <span className="text-slate2 text-sm md:text-base">
                                            {t.duration}
                                            {t.note && (
                                                <span className="ml-3 font-mono text-[10px] uppercase tracking-[0.15em] text-oxblood">
                                                    {t.note}
                                                </span>
                                            )}
                                        </span>
                                        <span className="font-serif text-3xl md:text-4xl text-ink group-hover:text-navy transition-colors duration-300">
                                            {t.price}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.15}>
                <div
                    data-testid="pricing-holiday-special"
                    className="mt-px bg-navy text-bone p-8 md:p-10 flex flex-col md:flex-row md:items-center gap-6 justify-between"
                >
                    <div className="flex items-start gap-4">
                        <Sun className="w-6 h-6 mt-1 shrink-0 text-bone/70" strokeWidth={1.5} />
                        <div>
                            <h3 className="font-serif text-2xl">School Holiday Specials</h3>
                            <p className="text-bone/60 text-sm mt-1">
                                Keep momentum through the break at a reduced rate.
                            </p>
                        </div>
                    </div>
                    <div className="flex gap-10">
                        <div>
                            <div className="font-serif text-4xl">$50</div>
                            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-bone/60 mt-1">
                                per hour · online
                            </div>
                        </div>
                        <div>
                            <div className="font-serif text-4xl">$60</div>
                            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-bone/60 mt-1">
                                per hour · in person
                            </div>
                        </div>
                    </div>
                </div>
            </Reveal>

            <p className="mt-6 text-xs text-slate2/80">
                Starting prices — may vary with demand. All sessions are individual,
                one-on-one. Contact us for current pricing.
            </p>
        </div>
    </section>
);
